export default function () {
  if (!this.isEdit) {
    this.afterPrepareShow()
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/form/resources/mounted.js